const debug = () => {
  return function () {
    return module.exports
  }
}

module.exports = debug
module.exports.disable = () => {}
module.exports.enable = () => {}
